

<template>
  <div class="mx-0 bg-slate-50 h-dvh" >
    <slot></slot>
  </div>
</template>

<script setup lang="ts">
import { useBootstrapStore } from "~~/store-legacy/bootstrap";
onMounted(() => {
  const bootStrapStore = useBootstrapStore();
  bootStrapStore.init();
  bootStrapStore.run();
});
</script>

<style scoped>

</style>